import { Select as AntSelect } from 'antd';

const Select = ({ valueName = 'id', labelName = 'name', options = [], value, ...props }) => {
  // Check if the selected value exists in the options array
  const selectedOption = options.find(option => option[valueName] === value);
  const defaultValue = selectedOption ? value : undefined;
  // console.log('selectedOption :>> ', selectedOption);
  // console.log('defaultValue :>> ', defaultValue);
  // console.log('options :>> ', options);

  return (
    <AntSelect
      placeholder="Select"
      {...props}
      defaultValue={defaultValue}
      value={selectedOption ? value : undefined}
      fieldNames={{ value: valueName, label: labelName }}
      optionFilterProp={labelName}
      options={options}
    />
  );
};

export default Select;
